export default {
  getQuery: (state) => (endpoint) => state.results[endpoint] || [],
  getQueryItem: (state) => (endpoint) => (itemId) =>
    (state.editQuery[endpoint] && state.editQuery[endpoint][itemId]) || {},
  getEditQuery: (state) => (endpoint) => state.editQuery[endpoint] || [],
};
